import React from 'react'

export default function CostSummaryCard({ costSummary, meterLabel = 'mi' }) {
  if (!costSummary) return null

  const items = [
    ['Total spent', `$${costSummary.total_cost?.toLocaleString(undefined, { minimumFractionDigits: 2 }) || '0.00'}`],
    [`Cost per ${meterLabel}`, costSummary.cost_per_unit != null ? `$${costSummary.cost_per_unit}` : '-'],
    [meterLabel === 'hrs' ? 'Hours logged' : 'Distance driven', costSummary.distance_driven != null ? `${costSummary.distance_driven.toLocaleString()} ${meterLabel}` : '-'],
    ['Service records', costSummary.maintenance_count || 0],
  ]

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-px bg-line border-y-[1.5px] border-ink mb-6">
      {items.map(([label, value]) => (
        <div key={label} className="bg-paper px-4 py-3">
          <p className="text-[11px] font-bold uppercase tracking-widest text-muted">{label}</p>
          <p className="mt-1 font-mono text-lg font-medium text-ink">{value}</p>
        </div>
      ))}
    </div>
  )
}
